import { on } from 'delegated-events';
import helpers from './helpers.js';

/*
===================================================================
Gallery
===================================================================
*/
export default (function () {
  return {

    init() {
      window.addEventListener('load', this.initGallery);
      window.addEventListener('keydown', this.closeGallery);
    },

    // Controls for closing the gallery using keydown event
    // return immediately if the key isn't the escape
    // Look for is-open and is-shown (gallery modal showing) 
    // Return if both can't be found, this means we still catch it if one still has a class
    closeGallery(e) {
      if (e.key !== 'Escape') return;

      const galleryDetail = document.querySelector('.js-gallery-detail.is-open');
      const galleryMain = document.querySelector('.js-gallery-main.is-shown');
      if (!galleryDetail && !galleryMain) return;

      galleryDetail.classList.remove('is-open');
      galleryMain.classList.remove('is-shown');

      // Remove lock scroll on the body in order to resume scroll action
      document.body.classList.remove('lock-scroll');
    },

    initGallery() {
      const pageHasGallery = document.querySelectorAll('.js-gallery-main').length;

      if (pageHasGallery) {
        const disableLinks = (gallery) => {
          const links = gallery.querySelectorAll('.js-gallery-launch');
          [...links].forEach((link) => {
            link.setAttribute('tabindex', '-1');
          });
        };
        const enableLinks = (gallery) => {
          const links = gallery.querySelectorAll('.js-gallery-launch');
          [...links].forEach((link) => {
            link.removeAttribute('tabindex');
          });
        };

        // Lock/Unlock the body scrolling
        const toggleBodyLock = () => document.body.classList.toggle('lock-scroll');

        // Set the caption based on string length for text to be added
        // Adds class if supplied text, removes if it's empty, defaults to empty
        const setCaption = (gallery, textStr = '') => {
          const captionParent = gallery.querySelector('.js-gallery-main');
          const caption = gallery.querySelector('.js-gallery-caption');
          if (!captionParent || !caption) return;

          caption.innerHTML = textStr;
          if (textStr.length) captionParent.classList.add('is-shown');
          if (!textStr.length) captionParent.classList.remove('is-shown');
        };

        const closeGallery = (gallery) => {
          toggleBodyLock();
          setCaption(gallery);

          const detail = gallery.querySelector('.js-gallery-detail');
          detail.classList.remove('is-open');
          const currentImage = parseInt(gallery.getAttribute('data-open-image'), 10);
          enableLinks(gallery);
          if (currentImage >= 0) {
            gallery.querySelectorAll('.js-gallery-launch')[currentImage].focus();
            gallery.removeAttribute('data-open-image');
          }
          document.activeElement.blur();
        };

        // image = { src: string, caption: string }
        // container is where we add the image
        const setGalleryImage = (image, container) => {
          if (!image.src || !container) return false;

          container.innerHTML = `<img src="${image.src}" alt="${image.caption ? image.caption : ''}" />`;
          return true;
        };

        const setModifier = () => {
          const main = document.querySelector('.js-gallery');
          const columns = main.querySelectorAll('.js-gallery-column');
          const items = main.querySelectorAll('.js-gallery-launch');

          if (columns.length < 2) {
            columns[0].classList.toggle('gallery__column--single');
          }

          if (items.length < 2) {
            items[0].classList.toggle('gallery__item--single');
          }
        };

        window.addEventListener('load', () => {
          setModifier();
        });

        on('click', '.js-gallery-launch', (e) => {
          e.preventDefault();
          toggleBodyLock();

          const thisImage = e.currentTarget;
          const img = thisImage.getAttribute('href');
          const gallery = thisImage.closest('.js-gallery');
          const detail = gallery.querySelector('.js-gallery-detail');
          const imgContainer = gallery.querySelector('.js-gallery-image');

          detail.classList.add('is-open');
          gallery.setAttribute('data-open-image', helpers.indexInParent(thisImage));

          const getCaption = thisImage.getAttribute('data-caption');
          if (getCaption) setCaption(gallery, `<p>${getCaption}</p>`);

          setGalleryImage({ src: img, caption: getCaption }, imgContainer);
          disableLinks(gallery);
        });

        // Close gallery cta (cross button top right of the screen)
        on('click', '.js-gallery-close', (e) => {
          e.preventDefault();
          const gallery = e.currentTarget.closest('.js-gallery');
          closeGallery(gallery);
        });
        on('click', '.js-gallery-background', (e) => {
          e.preventDefault();
          const gallery = e.currentTarget.closest('.js-gallery');
          closeGallery(gallery);
        });
      }
    },
  };
})();
